export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-checkbox-list/index.js